export enum ImageSize {
  Original = 1,
  Big = 2,
  Medium = 3,
  Small = 4,
};